<template>
  <div class="quiz-view__dropdown">
    <div class="dropdowns">
      <dropdown
        v-for="item in items"
        :key="`dropdown-${item.id}`"
        caption="..."
        :options="item.options"
        :label="item.text"
        @changed="(optionId, nextGroupId) => select(item.id, { optionId, nextGroupId })"
      />
    </div>
    <questions-nav
      @next="step(() => allSelected && $emit('next', selected))"
      @back="backStep(() => $emit('back'))"
      :showN="allSelected"
      :next="next"
      :previous="previous"
    />
  </div>
</template>
<script>
import Vue from "vue";
import Dropdown from "../components/Dropdown";
import QuestionsNav from "../components/QuestionsNav.vue";

export default {
  components: {
    Dropdown,
    QuestionsNav
  },
  data: function() {
    return {
      selected: {}
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    selectedIds: {
      type: Object,
      default: () => {}
    },
    previous: String,
    next: String
  },
  watch: {
    selectedIds: function(val, oldVal) {
      val && (this.selected = val);
    }
  },
  computed: {
    allSelected: function() {
      return Object.keys(this.selected).length === this.items.length;
    }
  },
  methods: {
    select: function(qId, data) {
      Vue.set(this.selected, qId, data);
    },
    step: function(callback) {
      callback();
    },
    backStep: function(callback) {
      callback();
      this.selectedIds && (this.selected = this.selectedIds);
    }
  },
  mounted: function() {
    this.selectedIds && (this.selected = this.selectedIds);
  },
  activated: function() {
    this.selectedIds && (this.selected = this.selectedIds);
  }
};
</script>
<style lang="scss" scoped>
.dropdowns {
  max-width: 475px;
  margin: 0 auto;
}
</style>